import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function Chackuser(code) {
    if (code) {
        let rs = ""
        let Url = "CSUSER/Chkuser?code=" + code;
        await console.log("Chackuser", genURL(Url));
        await axios.get(genURL(Url), { timeout: 5000 }).then(async (res) => {
            rs = await res.data[0].MYNAMETH
        }).catch((err) => {
            console.log(err);
        });
        return await rs
    }
};